import {
  REACT_APP_AUTH_AUTHORITY,
  REACT_APP_AUTH_CLIENTID,
  REACT_APP_AUTH_REDIRECT_URI,
  REACT_APP_AUTH_SCOPE,
} from "./config";

export const msalConfig = {
  auth: {
    clientId: `${REACT_APP_AUTH_CLIENTID}`,
    authority: `${REACT_APP_AUTH_AUTHORITY}`,
    redirectUri: `${REACT_APP_AUTH_REDIRECT_URI}`,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: [`${REACT_APP_AUTH_SCOPE}`],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
